/* eslint-disable react/no-danger */
import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { productCardDiscoverClicked, productCardClicked } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { countryMap } from '../../language.config';
import bannerConfiguration, { segmentTexts } from '../../utils/bannerconfig';
import { CATEGORY_URL, PRODUCT_URL } from '../../utils/shopify-endpoints';
import { SHOPIFY_URLS } from '../../utils/utils';

import '../../styles/home-revamp.scss';

export default function BannerCard({ size, product }) {
  const i18n = useI18n();
  const COUNTRY_LANGUAGE = i18n.activeLocale;
  const codes = COUNTRY_LANGUAGE.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const homePageData = i18n.t('home_page_new');

  const [windowWidth, setWindowWidth] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [bannerData, setBannerData] = useState({});

  function valueChange() {
    setIsMobile(window.innerWidth < 672);
    setWindowWidth(window.innerWidth);
  }

  const onProductDiscoverClick = (evt, productItem, productCategory) => {
    evt.stopPropagation();
    productCardDiscoverClicked(countryMap[country], productItem, productCategory);
  };

  useEffect(() => {
    const bannerDataLinks = bannerConfiguration(product, country);
    setBannerData(bannerDataLinks);
  }, [product, country]);

  useEffect(() => {
    valueChange();
    window.addEventListener('resize', () => {
      if (windowWidth > 672) {
        setTimeout(() => {
          valueChange();
        }, 500);
      }
    });
  }, []);

  return (
    <div className={size === 'small' ? 'cds--col-lg-8' : 'cds--col p-0'}>
      <div
        data-gumlet="true"
        loading="lazy"
        className={`image-box content-box-large ${size === 'small' ? 'content-box-large--half' : ''}`}
        data-bg={`../img/home-new/home-${product}-${size === 'small'
          ? 'section' : 'banner'}${isMobile ? '_mobile' : ''}.jpg`}
        // style={{
        //   backgroundImage: `url('../img/home-new/home-${product}-${size === 'small' ? 'section' : 'banner'}
        // ${isMobile ?'_mobile' : ''}.jpg')`
        // }}
        role="presentation"
        onClick={() => {
          productCardClicked(countryMap[country], segmentTexts[product].category, segmentTexts[product].category);
        }}
      >
        <div>
          <h3
            className={size === 'small' ? 'heading-small' : ''}
            data-lokalise=""
            data-key={`home_page_new::home_section::${product}_heading`}
            dangerouslySetInnerHTML={{ __html: homePageData.home_section[`${product}_heading`] }}
          />
          <p
            data-lokalise=""
            data-key={`home_page_new::home_section::${product}_detail`}
            dangerouslySetInnerHTML={{ __html: homePageData.home_section[`${product}_detail`] }}
          />
          <div className="homenew-buttonbox">
            <a
              href={`${SHOPIFY_URLS[COUNTRY_LANGUAGE]}${PRODUCT_URL}${bannerData.buynow}`}
              referrerPolicy="no-referrer"
              rel="noreferrer"
              className="web-btn"
              data-lokalise=""
              data-key="home_page_new::buy_now"
              target="_blank"
            >
              {homePageData.buy_now}
            </a>
            <a
              href={`${SHOPIFY_URLS[COUNTRY_LANGUAGE]}${CATEGORY_URL}${bannerData.learnmore}`}
              target="_blank"
              referrerPolicy="no-referrer"
              rel="noreferrer"
              className="learn-more"
              data-lokalise=""
              data-key="home_page_new::learn_more"
              onClick={(evt) => {
                onProductDiscoverClick(evt, segmentTexts[product].category, segmentTexts[product].category);
              }}
            >
              {homePageData.learn_more}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

BannerCard.propTypes = {
  size: PropTypes.string,
  product: PropTypes.string
};

BannerCard.defaultProps = {
  size: '',
  product: ''
};
